import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ContactSection from "../components/ContactSection";
import ContactInfo from "../components/ContactInfo";

const Contact = () => {
    const [formData, setFormData] = useState({
        prenom: "",
        nom: "",
        telephone: "",
        email: "",
        objet: "",
        message: "",
    });
    const [status, setStatus] = useState("");

    // Gestion des changements dans le formulaire
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Soumission du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("Envoi en cours...");

        try {
            const response = await axios.post(
                "https://api-ec.cinef-expertises.com/api/v1/contacts",
                formData
            );

            setStatus(response.data.message || "Message envoyé avec succès !");
            setFormData({
                prenom: "",
                nom: "",
                telephone: "",
                email: "",
                objet: "",
                message: "",
            });
        } catch (error) {
            console.error("Erreur lors de l'envoi :", error);
            setStatus(
                error.response?.data?.message ||
                    "Une erreur est survenue. Vérifiez votre serveur."
            );
        }
    };

    // Animation scroll
    useEffect(() => {
        const sections = document.querySelectorAll(".animate-on-scroll");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("animate");
                    }
                });
            },
            { threshold: 0.2 }
        );

        sections.forEach((section) => {
            observer.observe(section);
        });

        return () => {
            sections.forEach((section) => {
                observer.unobserve(section);
            });
        };
    }, []);

    return (
        <>
            <Header />

            <div className="contact-banner animate-on-scroll d-flex align-items-center">
                <div className="container text-white text-start">
                    <h1 className="fw-bold display-4">Contactez-Nous</h1>
                    <p className="lead">
                        Nous sommes à votre écoute pour toute question ou collaboration.
                    </p>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/" className="text-white text-decoration-none">
                                    Accueil
                                </Link>
                            </li>
                            <li
                                className="breadcrumb-item active text-white"
                                aria-current="page"
                            >
                                Contact
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <ContactSection />
            <ContactInfo />

            <div className="container contact-page animate-on-scroll">
                <h2 className="text-center title-green">Contactez-Nous</h2>

                {/* === Formulaire de contact relié au backend Laravel === */}
               

                {/* === Carte Google Maps === */}
                <div className="map-container">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1982.5515326243224!2d2.400856957671539!3d6.38069613984936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x102355c003d8ae37%3A0x4e8a4e13d75c13c4!2sCINEF%20FORMATION%20PROFESSIONNELLE%20AU%20BENIN!5e0!3m2!1sfr!2sbj!4v1746723569979!5m2!1sfr!2sbj"
                        allowFullScreen
                        loading="lazy"
                        title="Google Maps - Saint Rita, Bénin"
                    ></iframe>
                </div>
            </div>

            {/* === Styles === */}
            <style>{`
                .contact-banner {
                    position: relative;
                    background: linear-gradient(to right, rgba(255, 0, 0, 0.7), rgba(0, 150, 0, 0.7)), 
                                url("../assets/images/image14.png");
                    background-size: cover;
                    background-position: center;
                    height: 400px;
                    display: flex;
                    align-items: center;
                    color: white;
                    opacity: 0;
                    transform: translateY(50px);
                    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
                }

                .contact-page {
                    padding: 50px 0;
                    opacity: 0;
                    transform: translateY(50px);
                    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
                }

                .animate {
                    opacity: 1 !important;
                    transform: translateY(0) !important;
                }

                .breadcrumb {
                    background: transparent;
                    font-size: 18px;
                    padding: 0;
                }

                .breadcrumb-item a {
                    color: white;
                    font-weight: 500;
                }

                .breadcrumb-item.active {
                    font-weight: bold;
                }

                .title-green {
                    color: #008A44;
                    font-weight: bold;
                    margin-bottom: 20px;
                }

                .contact-form {
                    background: white;
                    padding: 30px;
                    border-radius: 10px;
                    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
                    width: 80%;
                    margin: 30px auto;
                }

                .btn-primary {
                    background: #008A44;
                    border: none;
                    padding: 10px 20px;
                    font-size: 16px;
                    border-radius: 5px;
                }

                .btn-primary:hover {
                    background: #006A33;
                }

                .map-container {
                    width: 100%;
                    height: 400px;
                    margin-top: 30px;
                }

                .map-container iframe {
                    width: 100%;
                    height: 100%;
                    border: none;
                }

                @media (max-width: 768px) {
                    .contact-form {
                        width: 100%;
                        padding: 20px;
                    }
                }
            `}</style>

            <Footer />
        </>
    );
};

export default Contact;
